import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const loadDashboard = create(actions.LOAD_DASHBOARD_DATA);
export const setDashboardStatus = create(actions.SET_DASHBOARD_STATUS);
